import PropTypes from 'prop-types';
import moment from 'moment';

export default {
	id: PropTypes.string,
	date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(moment)]),
	type: PropTypes.string,
	from: PropTypes.string,
	to: PropTypes.string,
	amount: PropTypes.string,
	reference: PropTypes.string,
	reasonId: PropTypes.number,
};
